(() => {
	angular
		.module('main')
		.controller(
			'QuoteInvoiceTemplatesUpdateController',
			QuoteInvoiceTemplatesUpdateController
		);

	QuoteInvoiceTemplatesUpdateController.$inject = [
		'$scope',
		'$routeParams',
		'$location',
		'settingsService'
	];

	function QuoteInvoiceTemplatesUpdateController(
		$scope,
		$routeParams,
		$location,
		settingsService
	) {
		$scope.templateId = $routeParams.templateId;
		$scope.templateType = $routeParams.templateType.toUpperCase();
		$scope.templateAction = $routeParams.templateAction.toUpperCase();

		settingsService.timeFormatSettings.take(1).subscribe(settings => {
			if (settings.qtTemplatesAvailable === false) {
				$location.url('/');
			}
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/quoteInvoiceTemplatesUpdateController.js